import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import logo from "./logo.png";
import { Accordion, Card, Button, Collapse, Table } from 'react-bootstrap';
import DateComponent from './subComponents/DateComponent'
import DatePriceProgress from './subComponents/DatePriceProgress'
import PaymentFormOrWhiteList from './subComponents/PaymentFormOrWhiteList'
import Price from "./subComponents/Price";
import WithdrawOrRefund from './subComponents/WithdrawOrRefund'
import AccountInfo from './subComponents/AccountInfo'
import DisplayedWeiData from './subComponents/DisplayedWeiData'
import HardCap from './subComponents/HardCap'
import CarouselVideos from './subComponents/CarouselVideos'
import { Web3StatusContext } from "./contexts/Web3StatusContext";
import { Trans } from 'react-i18next';


const { AccountData, ContractData, ContractForm } = newContextComponents;

class CrowdSale extends React.Component {
  static contextType = Web3StatusContext;

  state = {warningOpen: true};

  componentDidMount() {
    const { drizzle } = this.props;
    const contract = drizzle.contracts.GAMEFORESTSale;

    contract.methods.getTime(0).call().then(function(result) {
      const nowUnix = Math.floor(Date.now() / 1000);
    });
  }

  render() {
    const { activeAccount } = this.context;

    var increase_non_whitelist_text = (<Trans>crowdsale.10_increase</Trans>);
    var increase_text = (<span><Trans>crowdsale.price_increase</Trans><br/>
      <span style={{color:'red'}}>{increase_non_whitelist_text}</span></span>);
    increase_text = '';
    increase_non_whitelist_text = '';

    var vesting_change_warning = (<Trans>crowdsale.vesting_change_warning</Trans>);
    vesting_change_warning = '';

    var vesting_warning_text = (<span style={{color:'red'}}><Trans>crowdsale.vesting_warning</Trans>
    <br/>
    <DateComponent drizzle={this.props.drizzle}
      drizzleState={this.props.drizzleState}
      dateName="getTime"
      getterParameter={4}>
    </DateComponent></span>);
    vesting_warning_text = '';

    var paymentFormOrWhiteList = (
        <PaymentFormOrWhiteList
          drizzle={this.props.drizzle}
          drizzleState={this.props.drizzleState}>
        </PaymentFormOrWhiteList>);

    var countrywarning =
    <div><Button
    onClick={function() {
      this.setState((prevState, props) => ({
        warningOpen: !prevState.warningOpen
      }));
    }.bind(this)}
    aria-controls="example-collapse-text"
    aria-expanded={this.state.warningOpen}
  >
    Toggle Warning
  </Button>
  <Collapse in={this.state.warningOpen}>
    <div id="example-collapse-text">
    This is not for users who reside in the US, Canada, China, Democratic People’s Republic of Korea, Cuba, Syria, Iran, Republic of Crimea, Iran, Korea (North), Syrian Arab Republic, Cuba, Crimea region of Ukraine.<br/>
    Please check your local regulations.
    </div>
  </Collapse></div>;

    if(this.context.i18n.languages[0] == 'tr')
      countrywarning = '';

    var price_table_head = (
      <thead>
              <tr>
                <th><Trans>crowdsale.opening_price</Trans></th>
                <th><Trans>crowdsale.closing_price</Trans></th>
              </tr>
            </thead>
            
    );
    price_table_head = '';

    var price_table_body = (<tbody>
      <tr>
        <td width="50%">
          <ContractData
            drizzle={this.props.drizzle}
            drizzleState={this.props.drizzleState}
            contract="GAMEFORESTSale"
            method="initialRate"
          />{" "}
          <ContractData
            drizzle={this.props.drizzle}
            drizzleState={this.props.drizzleState}
            contract="GAMEFOREST"
            method="symbol"
            hideIndicator
          />{"/BNB"}
          <br/>
          <Price
            drizzle={this.props.drizzle}
            drizzleState={this.props.drizzleState}
            priceName="initialRate">
          </Price>
          {increase_text}
        </td>
        <td>
          <ContractData
            drizzle={this.props.drizzle}
            drizzleState={this.props.drizzleState}
            contract="GAMEFORESTSale"
            method="finalRate"
          />{" "}
          <ContractData
            drizzle={this.props.drizzle}
            drizzleState={this.props.drizzleState}
            contract="GAMEFOREST"
            method="symbol"
            hideIndicator
          />{"/BNB"}
          <br/>
          <Price
            drizzle={this.props.drizzle}
            drizzleState={this.props.drizzleState}
            priceName="finalRate">
          </Price>
          <span style={{color:'red'}}>{increase_non_whitelist_text}</span>
        </td>
      </tr>
    </tbody>);
    price_table_body = '';

    return (
      <div className="App">
        <div>
          <img src={logo} alt="drizzle-logo" />
          <h1><Trans>crowdsale.title</Trans></h1>
          <p>
          <Trans>crowdsale.subtitle</Trans>
          </p>
          <div>
            <a href="https://www.the-game-forest.finance/" target="_blank"><Trans>crowdsale.homepage</Trans></a>
          </div>
          <Accordion defaultActiveKey="0">
            <Card>
              <Accordion.Collapse eventKey="0">
                <AccountInfo
                drizzle={this.props.drizzle}
                drizzleState={this.props.drizzleState}
                accountIndex={0}
                units="ether"
                precision={3}
                />
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </div>

        <div>
          <p>
            <strong><Trans>crowdsale.balance</Trans></strong>
            <DisplayedWeiData
              drizzle={this.props.drizzle}
              drizzleState={this.props.drizzleState}
              contract="GAMEFOREST"
              method="balanceOf"
              methodArgs={[activeAccount]}
            />{" "}
            <ContractData
              drizzle={this.props.drizzle}
              drizzleState={this.props.drizzleState}
              contract="GAMEFOREST"
              method="symbol"
              hideIndicator
            />
          </p>
          {countrywarning}
          
          <Table striped bordered hover>
            <thead>
              <tr>
                <th colSpan="2">
                  <DatePriceProgress
                      drizzle={this.props.drizzle}
                      drizzleState={this.props.drizzleState}
                      firstDateName={1}
                      lastDateName={3}
                      firstRateName="initialRate"
                      lastRateName="finalRate"
                      currentRateName="getCurrentRate"
                      textOnly="true">

                  </DatePriceProgress>
                </th>
              </tr>
            </thead>
            {price_table_head}
            {price_table_body}
            <thead>
              <tr>
                <th colSpan="2">
                  {paymentFormOrWhiteList}
                </th>
              </tr>
              <tr>
                <th colSpan="2">
                  {vesting_warning_text}
                  <br/>
                  {vesting_change_warning}
                </th>
              </tr>
            </thead>
          </Table>
        </div>
        <div>
          <WithdrawOrRefund
            drizzle={this.props.drizzle}
            drizzleState={this.props.drizzleState}>

          </WithdrawOrRefund>
        </div>
        <div className="section">
          <h2><Trans>crowdsale.gameforest_token</Trans></h2>
          <Table striped bordered hover>
            <thead>
              <tr>
                
              </tr>
            </thead>
            <tbody>
              <tr>
                <td align="right" width="50%"><Trans>crowdsale.total_supply</Trans></td>
                <td align="left">
                {"10000000000000 "}
                <ContractData
                  drizzle={this.props.drizzle}
                  drizzleState={this.props.drizzleState}
                  contract="GAMEFOREST"
                  method="symbol"
                  hideIndicator/>
                </td>
              </tr>
              <tr>
                <td align="right"><Trans>crowdsale.soft_cap</Trans></td>
                <td align="left">
                  <DisplayedWeiData
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    contract="GAMEFORESTSale"
                    method="goal"
                  />{" BNB"}
                </td>
              </tr>
              <tr>
                <td align="right"><Trans>crowdsale.hard_cap</Trans></td>
                <td align="left">
                  <HardCap
                    drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    contract="GAMEFORESTSale"
                    method="cap"
                  />{" BNB"}
                </td>
              </tr>
              <tr>
                <td align="right"><Trans>crowdsale.opening_date</Trans></td>
                <td align="left">
                  <DateComponent drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    dateName="getTime"
                    getterParameter={1}>
                  </DateComponent>
                </td>
              </tr>
              <tr>
                <td align="right"><Trans>crowdsale.closing_date</Trans></td>
                <td align="left">
                  <DateComponent drizzle={this.props.drizzle}
                    drizzleState={this.props.drizzleState}
                    dateName="getTime"
                    getterParameter={3}>
                  </DateComponent>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
        <CarouselVideos></CarouselVideos>
      </div>
    );
  };
}

export default CrowdSale;